import React, {useState, useEffect} from 'react';
import { useForm, Controller} from 'react-hook-form';
import { capitalize } from 'lodash';
import Select from "react-select";
import categoryService from '../../services/CategoryService';

export default function SlideActionCategory({show,onClose,onFetchCategories,search,category}) {
    const defaultValues = {
        name: "",
        view: "Scheda",
        status: "true",
        parent:null
    };
    const { register, control, handleSubmit, reset,formState: { errors } } = useForm({
        defaultValues
    });
    const [message, setMessage] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(true);

    const closeSlide = () => {
        setErrorMsg("");
        setMessage("");
        onClose();
        reset({...defaultValues});
    };

    const normalizeData = (data) => {
        if(data.parent) {
            const parentNormalized = {
              id_category: data.parent.id_category,
              name: data.parent.name
            };
            data = {
                ...data,
                parent: parentNormalized
            }
        }
        return Object.keys(data).reduce((acc, key) => {
            let value = data[key];

            if (typeof value === "string") {
                value = value.trim();
                value = capitalize(value);
            }

            acc[key] = value;
            return acc;
        }, {});
    };

    const handleActionCategory= async (data) => {
        const normalizedData = normalizeData(data);
        if(!data?.id_category){
            categoryService.add(normalizedData,reset)
                .then((res) => {
                    setMessage("Categoria aggiunta con successo!");
                    setErrorMsg("");
                    onFetchCategories(search);
                    reset({...defaultValues});
                }).catch((error) => {
                    console.error("Error add category: ", error);
                    setMessage("");
                    setErrorMsg("Errore aggiunta categoria. Riprova.");
                }
            );
        } else {
            categoryService.update(normalizedData)
                .then((res) => {
                    setMessage("Categoria modificata con successo!");
                    setErrorMsg("");
                    onFetchCategories(search);
                }).catch((error) => {
                    console.error("Error update category: ", error);
                    setMessage("");
                    setErrorMsg("Errore aggiornamento categoria. Riprova.");
                }
            );
        }
    }

    const fetchCategories= async () => {
        try {
            const res = await categoryService.getAll();
            const resultsData = res.data || [];
            if(category){
                const filterParent = resultsData.find(s => s.name === category.parent);
                reset({
                    ...category,
                    parent: filterParent
                });
            }
            setResults(resultsData);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching Categories', error);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, [category, reset]);

    return (
  	    <div className={`offcanvas offcanvas-end ${show ? "show" : ""}`}>
            <div className="offcanvas-header border-bottom">
                <h5 className="offcanvas-title">{category ? "Modifica " : "Aggiungi "} Categoria</h5>
                <button onClick={closeSlide} className="btn-close text-reset"></button>
            </div>
            <div className="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
                {errorMsg && <div className="mb-6 text-center alert alert-outline-danger">{errorMsg}</div>}
                {message && <div className="mb-6 text-center alert alert-outline-success">{message}</div>}
                <form className="add-new-user pt-0" onSubmit={handleSubmit(handleActionCategory)}>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Nome*</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.name ? "is-invalid" : ""}`}>
                                    <i className="bx bx-store" ></i>
                                </span>
                                <input type="text" className={`form-control ${errors.name ? "is-invalid" : ""}`}
                                    {...register('name', { required: 'Nome richiesto' })}
                                />
                            </div>
                            {errors.name && <div className="invalid-input">{errors.name.message}</div>}
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Categoria Padre</label>
                                <Controller
                                name="parent"
                                control={control}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            isClearable
                                            placeholder="Seleziona una categoria"
                                            classNamePrefix='filter'
                                            options={results}
                                            getOptionLabel={(e) => e.name}
                                            getOptionValue={(e) => e.id_category}
                                        />
                                    )}
                                />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">View</label>
                            <select className={`form-select ${errors.view ? "is-invalid" : ""}`}
                                type="text"
                                placeholder="Seleziona una vista"
                                {...register('view', { required: 'Richiesto' })}
                            >
                                <option value="Scheda">Scheda</option>
                                <option value="Elenco">Elenco</option>
                            </select>
                            {errors.view && <div className="invalid-input">{errors.view.message}</div>}
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Stato</label>
                            <select className={`form-select ${errors.status ? "is-invalid" : ""}`}
                                type="text"
                                placeholder="Seleziona uno stato"
                                {...register('status', { required: 'Richiesto' })}
                            >
                                <option value="true">Attivo</option>
                                <option value="false">Non Attivo</option>
                            </select>
                            {errors.status && <div className="invalid-input">{errors.status.message}</div>}
                        </div>
                    </div>
                    <button type="submit" className="btn btn-primary me-3">Invia</button>
                    {!category && <button type="button" onClick={() =>   reset({...defaultValues})} className="btn btn-label-danger">Cancella</button>}
                </form>
            </div>
        </div>
    );
}